import LocationForm from "screens/private/location/form";
export default LocationForm;
